import { render, staticRenderFns } from "./ArticleWriter.vue?vue&type=template&id=12f8b075"
import script from "./ArticleWriter.vue?vue&type=script&lang=js"
export * from "./ArticleWriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports